'use client';

import NextTopLoader from 'nextjs-toploader';

export default function Template({ children }: { children: React.ReactNode }) {
  return (
    <div>
      <NextTopLoader height={6} color="#000" showSpinner={false} />

      {children}
    </div>
  );
}
